import Icon from "./Icon"

export default function ReorderIcon({ onClick }) {
  return (
    <Icon
      draggable={false}
      size="small"
      name="bars-3"
      outline
      onClick={onClick}
      className="cursor-move text-neutral-7"
    />
  )
}
